import { Injectable, Injector } from '@angular/core';
import { ProgramType } from '../../../../shared/enums/program-type.enum';
import { UserInfo } from '../../../../shared/models/auth/user-info.model';
import { ASidebarBuilder } from './a-sidebar-builder';
import { FtSidebarBuilder } from './ft-sidebar-builder';
import { PeSidebarBuilder } from './pe-sidebar-builder';
import { PpSidebarBuilder } from './pp-sidebar-builder';
import { MtSidebarBuilder } from './mt-sidebar-builder';

@Injectable()
export class SidebarBuilderFactory {
  constructor(private readonly injector: Injector) {}

  public get(userInfo: UserInfo): ASidebarBuilder {
    if (!userInfo.CurrentSiteId || !userInfo.CurrentProgramId) {
      return this.injector.get(FtSidebarBuilder);
    }

    switch (userInfo.CurrentProgram.Type) {
      case ProgramType.FieldTraining:
        return this.injector.get(FtSidebarBuilder);
      case ProgramType.PerformanceEvaluation:
        return this.injector.get(PeSidebarBuilder);
      case ProgramType.ProbationaryPeriod:
        return this.injector.get(PpSidebarBuilder);
      case ProgramType.Mentoring:
        return this.injector.get(MtSidebarBuilder);
      default:
        return null;
    }
  }
}
